var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9V3h1l5 4.824V9h-6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.474 2a2 2 0 011.394.566l4.526 4.4-1.045 1.076-4.527-4.4a.5.5 0 00-.348-.142H4a.5.5 0 00-.5.5v16a.5.5 0 00.5.5h12a.5.5 0 00.5-.5v-1H18v1a2 2 0 01-2 2H4a2 2 0 01-2-2V4a2 2 0 012-2h7.474zM18 11V8.4a2 2 0 00-.606-1.433L16.35 8.042a.5.5 0 01.151.359V11H18z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.424 11.576L22.85 15l-3.425 3.424-.848-.848 1.976-1.976H11v-1.2h9.552l-1.976-1.976.848-.848z",
    fill: "currentColor"
  })));
}
export default SvgExportReport;